import { getLang, getSite } from "@/lib/getSite";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import useSWRImmutable from "swr/immutable";

export function useSite() {
  const url = usePathname();

  return useMemo(() => {
    return getSite(url);
  }, [url]);
}

export function useLang() {
  const url = usePathname();

  return useMemo(() => {
    return getLang(url);
  }, [url]);
}

interface LangItem {
  name: string;
  label: string;
  default: boolean;
  id: number;
}

export function useLanguages() {
  return useSWRImmutable("language_data", async () => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_DATASERVER}/items/language?fields=*.*`
    ).then((res) => res.json());

    return res?.data as LangItem[] | undefined;
  });
}

export function useLangData() {
  const lang = useLang();
  const { data: langDatas } = useLanguages();
  return langDatas?.find((i) => i.id === lang);
}
